import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  loginInfoTitle: (
    <PortalMessage id='t.app.login.loginInfo.title' defaultMessage='Ottimizza il Tuo Business con Merchant Portal' />
  ),
  loginInfoSubTitle: (
    <PortalMessage
      id='t.app.login.loginInfo.subTitle'
      defaultMessage='Accedi al nostro portale e scopri come gestire facilmente i tuoi stabilimenti, monitorare le transazioni e migliorare le tue performance. Il futuro del tuo business è a portata di clic!'
    />
  ),
  loginFormTitle: <PortalMessage id='t.app.login.loginForm.title' defaultMessage='Merchant Portal' />,
  loginFormSubtitle: (
    <PortalMessage
      id='t.app.login.loginForm.subtitle'
      defaultMessage='L’area riservata agli esercenti. <br/>Accedi con le tue credenziali.'
    />
  ),
  signInCta: <PortalMessage id='t.app.login' defaultMessage='Accedi' />,
  signUpLabel: <PortalMessage id='t.app.login.loginPage.signUp.label' defaultMessage='Non hai un profilo?' />,
  signUpCta: <PortalMessage id='t.app.login.loginPage.signUp.cta' defaultMessage='REGISTRATI ORA' />,
  rememberUsername: (
    <PortalMessage
      id='t.app.login.loginPage.rememberUsername.link'
      defaultMessage='Ricorda email al prossimo accesso'
    />
  ),
  forgotCredentials: (
    <PortalMessage id='t.app.login.loginPage.forgotCredentials.link' defaultMessage='HAI DIMENTICATO LE CREDENZIALI?' />
  ),
  requiredField: <PortalMessage id='t.app.error.requiredField' defaultMessage='Il campo è obbligatorio' />,
  invalidEmailFormat: <PortalMessage id='t.app.error.invalidEmailFormat' defaultMessage='Formato email non valido' />,
  invalidRefreshToken: (
    <PortalMessage
      id='t.app.login.loginPage.invalidRefreshToken.text'
      defaultMessage='Per ragioni di sicurezza inserisci le tue credenziali per accedere.'
    />
  ),
  email: <PortalMessage id='t.app.email' defaultMessage='Email' />,
  password: <PortalMessage id='t.app.password' defaultMessage='Password' />,
  greetings: (dynamicParam) => (
    <PortalMessage
      id='t.app.login.loginPage.greetings.text'
      defaultMessage='Ciao {dynamicParam}'
      values={{ dynamicParam }}
    />
  ),
  areNotYou: <PortalMessage id='t.app.login.loginPage.areNotYou.text' defaultMessage='NON SEI TU?' />,
  copyrightLabel: (
    <PortalMessage
      id='t.app.login.loginPage.copyright.label'
      defaultMessage='© Nexi Payments S.p.A. 2017-2026. All Rights Reserved. - Membro del Gruppo IVA Nexi P.IVA 10542790968'
    />
  ),

  appPromoTitle: <PortalMessage id='t.app.login.appPromo.title' defaultMessage='Nexi Business' />,
  appPromoSubtitle: (
    <PortalMessage id='t.app.login.appPromo.subtitle' defaultMessage='La libertà di gestire il tuo business, ovunque' />
  ),
  appPromoButtonText: <PortalMessage id='t.app.login.appPromo.buttonText' defaultMessage="Scarica l'app" />,
  appPromoAltTextImg: <PortalMessage id='t.app.login.appPromo.altTextImg' defaultMessage='Nexi Business Icon App' />,
  invalidCredentials: (
    <PortalMessage
      id='t.app.login.loginPage.invalidCredentials.text'
      defaultMessage='I dati che hai inserito non sono validi, riprova.'
    />
  ),
  emailNotValid: <PortalMessage id='t.app.error.email.notvalid' defaultMessage='Email non valida' />,
  passwordNotValid: <PortalMessage id='t.app.error.password.notvalid' defaultMessage='Password non valida' />,
  newsSectionTitle: <PortalMessage id='t.app.login.newsSectionTitle' defaultMessage='Comunicazioni & News' />,
  supportCta: <PortalMessage id='t.app.support' defaultMessage='Assistenza' />
}

export default formattedMessage
